import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import { Fragment, useMemo } from 'react';
import { Union } from 'ts-toolbelt';

import { NBSP } from '~/common/constants';
import { CuriosityUserChip } from '~/components/CuriosityUserChip/CuriosityUserChip';
import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';

export type UserChipCellValue = Union.Nullable<string>;

interface UserSelectCellProps<R extends GridValidRowModel = any> {
  value: Union.Nullable<string | string[]>;
  row: R;
  ns?: CuriosityNamespaceType;
}

export const UserChipCell = <R extends GridValidRowModel = any>({ value: valueProp, ns }: UserSelectCellProps<R>) => {
  const values: Union.Nullable<UserChipCellValue[]> = useMemo(() => {
    if (valueProp) {
      return Array.isArray(valueProp) ? valueProp : [valueProp];
    }
    return null;
  }, [valueProp]);

  if (values) {
    const result = values
      .map((value, index) =>
        value ? (
          <Fragment key={index}>
            {index > 0 ? NBSP : null}
            <CuriosityUserChip key={index} ns={ns} userId={value} />
          </Fragment>
        ) : null,
      )
      .filter(Boolean);

    return result.length ? <>{result}</> : null;
  }

  return <>{NULLISH_CELL_VALUE}</>;
};
